.container {
    min-width: 400px;
}

.list-container {
    overflow-y: auto;
    padding: 8px;
}
